// import React from "react";
// import Card from "components/Card/Card.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import CardBody from "components/Card/CardBody.jsx";

// export function ProductCardBase({ product, classes, onSelect }) {
// 	return (
// 		<Card plain product>
// 			<CardHeader noShadow image>
// 				<div
// 					style={{
// 						display: "flex",
// 						justifyContent: "center",
// 					}}
// 				>
// 					<a
// 						style={{ cursor: "pointer" }}
// 						onClick={() =>
// 							onSelect(
// 								product.Producto[0],
// 								product.Producto[0].idCategoria,
// 								product._id,
// 								product
// 							)
// 						}
// 					>
// 						<img
// 							style={{
// 								width: "150px",
// 								height: "200px",
// 								objectFit: "cover",
// 							}}
// 							src={
// 								product.Producto[0].ImagenProducto != null
// 									? "data:image/png;base64," +
// 									  product.Producto[0].ImagenProducto
// 									: "https://placehold.co/150x200"
// 							}
// 							alt="Product image"
// 						/>
// 					</a>
// 				</div>
// 			</CardHeader>
// 			<CardBody plain>
// 				<a
// 					onClick={() =>
// 						onSelect(
// 							product.Producto[0],
// 							product.Producto[0].idCategoria,
// 							product._id,
// 							product
// 						)
// 					}
// 				>
// 					{/* <a href="#pablo"> */}
// 					<h4 className={classes.cardTitle}>
// 						{product.Producto[0].NombreProducto}
// 					</h4>
// 				</a>
// 				<center>
// 					<p className={classes.description}>
// 						{product.Producto[0].Descripcion}
// 					</p>
// 				</center>
// 			</CardBody>
// 			{/* Tu resto de contenido */}
// 		</Card>
// 	);
// }

import React from "react";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

export function ProductCardBase({ product, classes, onSelect }) {
	// Accesos seguros + derivación de stock/discount
	// const p =
	// 	product && product.Producto && product.Producto.length > 0
	// 		? product.Producto[0]
	// 		: {};

	const name = product.NombreProducto || "Producto";
	const desc = product.Descripcion || "";
	const imgBase64 = product.ImagenProducto;
	const categoryId = product.idCategoria;

	// Campos de stock/discount con fallback
	const stock =
		product.Stock !== undefined
			? product.Stock
			: product.Existencias !== undefined
			? product.Existencias
			: product && product.Stock !== undefined
			? product.Stock
			: product && product.existencias !== undefined
			? product.existencias
			: 0;

	const discountPercent =
		product.Descuento !== undefined
			? product.Descuento
			: product.discountPercent !== undefined
			? product.discountPercent
			: 0;

	const handleSelect = () => {
		if (typeof onSelect === "function") {
			onSelect(product, categoryId, product ? product._id : null, product);
		}
	};

	// Función para determinar si imgBase64 es una URL o base64
	const getImageSrc = () => {
		if (!imgBase64) {
			return "https://placehold.co/150x200?text=Sin+imagen";
		}

		// Verificar si es una URL (http:// o https://)
		if (
			typeof imgBase64 === "string" &&
			(imgBase64.startsWith("http://") || imgBase64.startsWith("https://"))
		) {
			return imgBase64;
		}

		// Si no es URL, asumir que es base64
		return "data:image/png;base64," + imgBase64;
	};

	return (
		<Card plain product>
			<CardHeader noShadow image>
				<div style={{ display: "flex", justifyContent: "center" }}>
					{/* Contenedor relativo para superponer badges */}
					<div
						style={{
							position: "relative",
							width: 150,
							height: 200,
							borderRadius: 8,
							overflow: "hidden",
						}}
					>
						{/* Descuento (arriba derecha) */}
						{/* {discountPercent > 0 && (
							<div
								aria-label={"Descuento " + discountPercent + "%"}
								style={{
									position: "absolute",
									top: 8,
									right: 8,
									padding: "4px 8px",
									fontSize: 12,
									fontWeight: 700,
									background: "rgba(255, 87, 34, 0.95)",
									color: "#fff",
									borderRadius: 999,
									boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
									pointerEvents: "none",
								}}
							>
								🏷️ {discountPercent}%
							</div>
						)} */}

						{/* Agotado */}
						{/* {stock <= 0 && (
							<div
								aria-label="Agotado"
								style={{
									position: "absolute",
									top: 10,
									left: -40,
									transform: "rotate(-20deg)",
									background: "rgba(220, 53, 69, 0.98)",
									color: "#fff",
									fontSize: 12,
									fontWeight: 800,
									letterSpacing: 1,
									padding: "6px 48px",
									boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
									pointerEvents: "none",
								}}
							>
								AGOTADO
							</div>
						)} */}

						{/* Pocas piezas */}
						{/* {stock > 0 && stock <= 3 && (
							<div
								aria-label={stock + " restantes"}
								style={{
									position: "absolute",
									top: 8,
									left: 8,
									padding: "4px 8px",
									fontSize: 12,
									fontWeight: 700,
									background: "rgba(255, 193, 7, 0.95)",
									color: "#212121",
									borderRadius: 6,
									boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
									pointerEvents: "none",
								}}
							>
								{stock} restantes
							</div>
						)} */}

						{/* Imagen clickable */}
						<a
							style={{
								cursor: "pointer",
								display: "block",
								width: "100%",
								height: "100%",
							}}
							onClick={handleSelect}
						>
							<img
								style={{
									width: "100%",
									height: "100%",
									objectFit: "cover",
									objectPosition: "center center",
									display: "block",
								}}
								src={getImageSrc()}
								alt={name}
							/>
						</a>
					</div>
				</div>
			</CardHeader>

			<CardBody plain>
				<a onClick={handleSelect} style={{ cursor: "pointer" }}>
					<h4 className={classes && classes.cardTitle}>{name}</h4>
				</a>
				<center>
					<p className={classes && classes.description}>{desc}</p>
				</center>
			</CardBody>
		</Card>
	);
}
